import { Box } from "@mui/material";
import { RaffleStatus } from "../raffle/status";

export const Dashboard = () => (
    <Box>
        <RaffleStatus />
    </Box>
)